import { render } from "./CreateWitness.vue?vue&type=template&id=606e5cbe&scoped=true"
import script from "./CreateWitness.vue?vue&type=script&lang=js"
export * from "./CreateWitness.vue?vue&type=script&lang=js"

import "./CreateWitness.vue?vue&type=style&index=0&id=606e5cbe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606e5cbe"]])

export default __exports__